export default __webpack_public_path__ + "static/media/down-arrow-green.icon.192ed0d8.svg";